import { getOptionByValueInList } from '../../utils/general/general-utils';

const TIPO_PRODUTO_IMPORTACAO = 'IMPORTACAO';
const TIPO_PRODUTO_EXPORTACAO = 'EXPORTACAO';
const TIPO_PRODUTO_AGENCIAMENTO = 'AGENCIAMENTO';
const TIPO_PRODUTO_ASSESSORIA = 'ASSESSORIA';
const TIPO_PRODUTO_LI = 'LI';
const TIPO_PRODUTO_FATURA = 'FATURA';
const TIPO_PRODUTO_AGENCIAMENTO_IMPORTACAO = 'AGENCIAMENTO_IMPORTACAO';
const TIPO_PRODUTO_AGENCIAMENTO_EXPORTACAO = 'AGENCIAMENTO_EXPORTACAO';

const TIPO_PRODUTO_LIST = [
  {
    label: 'com.muralis.qcx.exportacao.label',
    value: TIPO_PRODUTO_EXPORTACAO,
  },
  {
    label: 'com.muralis.qcx.importacao.label',
    value: TIPO_PRODUTO_IMPORTACAO,
  },
  {
    label: 'Assessoria',
    value: TIPO_PRODUTO_ASSESSORIA,
  },
  {
    label: 'LI',
    value: TIPO_PRODUTO_LI,
  },
  {
    label: 'Fatura',
    value: TIPO_PRODUTO_FATURA,
  },
  {
    label: 'Agenciamento Importação',
    value: TIPO_PRODUTO_AGENCIAMENTO_IMPORTACAO,
  },
  {
    label: 'Agenciamento Exportação',
    value: TIPO_PRODUTO_AGENCIAMENTO_EXPORTACAO,
  },

];

const isTipoProdutoImportacao = (tipoProduto) => tipoProduto === TIPO_PRODUTO_IMPORTACAO;

const isTipoProdutoExportacao = (tipoProduto) => tipoProduto === TIPO_PRODUTO_EXPORTACAO;

const isTipoProdutoAssessoria = (tipoProduto) => tipoProduto === TIPO_PRODUTO_ASSESSORIA;

const isTipoProdutoLI = (tipoProduto) => tipoProduto === TIPO_PRODUTO_LI;

const isTipoProdutoFatura = (tipoProduto) => tipoProduto === TIPO_PRODUTO_FATURA;

function getTipoProdutoLabelByValue(value) {
  const foundOption = getOptionByValueInList(TIPO_PRODUTO_LIST, value);
  return foundOption && foundOption?.label;
}

const TipoProdutoUtils = Object.freeze({
  LIST: TIPO_PRODUTO_LIST,
  IMPORTACAO: TIPO_PRODUTO_IMPORTACAO,
  EXPORTACAO: TIPO_PRODUTO_EXPORTACAO,
  AGENCIAMENTO: TIPO_PRODUTO_AGENCIAMENTO,
  ASSESSORIA: TIPO_PRODUTO_ASSESSORIA,
  LI: TIPO_PRODUTO_LI,
  FATURA: TIPO_PRODUTO_FATURA,
  AGENCIAMENTO_IMPORTACAO: TIPO_PRODUTO_AGENCIAMENTO_IMPORTACAO,
  isImportacao: isTipoProdutoImportacao,
  isExportacao: isTipoProdutoExportacao,
  isAssessoria: isTipoProdutoAssessoria,
  isLI: isTipoProdutoLI,
  isFatura: isTipoProdutoFatura,
  getLabelByValue: getTipoProdutoLabelByValue,
});

export {
  TIPO_PRODUTO_ASSESSORIA,
  TIPO_PRODUTO_EXPORTACAO,
  TIPO_PRODUTO_FATURA,
  TIPO_PRODUTO_IMPORTACAO,
  TIPO_PRODUTO_AGENCIAMENTO,
  TIPO_PRODUTO_LI,
  TIPO_PRODUTO_LIST,
  TipoProdutoUtils,
  getTipoProdutoLabelByValue,
  isTipoProdutoAssessoria,
  isTipoProdutoExportacao,
  isTipoProdutoImportacao,
};
